import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_include_sandblasting_its_processes'

export const dataPointDefinition = {
  retracedId: 'does_facility_include_sandblasting_its_processes',
  name: 'Does the facility include sandblasting in its processes?',
  description: '',
  meta: {
    slcpMeta: {
      key: 'fp-pro-3',
      number: 'FP-PRO-3',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: 'yes-no',
      versionImported: '1.7.0',
      verificationTypeReq: 'Facility Profile',
      verificationSelectionOptList: 'verf-f-list',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '[1]',
      machineShowHide: '[1]',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'yes_no',
      name: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['yes_no'],
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-pro-3', version: '1.7.0', provider: 'slcp'}],
  sortingId: 28920,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
